<app-banner [loading]="loading" [info]="true" [heading]="'Remediation dashboard'" [subHeading]="'View registrants in remediation, NIR and NoR'">

  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

  </div>

</app-banner>

@if (!loading) {
  <div class="content no-boxes fadein">
    @if (data.length > 0) {
      <div style="padding-bottom: 20px">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 100px">Submission deadline</th>
              <th class="text-right" style="width: 10px">Remediation</th>
              <th class="text-right" style="width: 100px">NIR</th>
              <th class="text-right" style="width: 100px">NOR</th>
            </tr>
          </thead>
          <tbody>
            @for (row of data; track row) {
              <tr>
                <td>{{ row.submissionDeadline | utcDate }} </td>
                <td class="text-right" [class.clickable]="!!row.Remediation" (click)="showRegistrants(row.submissionDeadline, RevalidationStatus.Remediation, row.Remediation)"> {{ row.Remediation
                || '-' }} </td>
                <td class="text-right" [class.clickable]="!!row.NIR"  (click)="showRegistrants(row.submissionDeadline, RevalidationStatus.NIR, row.NIR)"> {{ row.NIR || '-' }}
                </td>
                <td class="text-right" [class.clickable]="!!row.NOR"  (click)="showRegistrants(row.submissionDeadline, RevalidationStatus.NOR, row.NOR)"> {{ row.NOR || '-' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (!data.length) {
      <div class="no-data">
        No data available
      </div>
    }
  </div>
}